import type { ReactNode } from 'react';
import { useDataRoomAccess } from '@/hooks/useDataRoomAccess';
import type { TeamMember } from '../api/team.api';
import { DataRoomSeatCell } from '../components/DataRoomSeatCell';

/**
 * The Team Access table's Data Room Access cell renderer, or undefined when
 * the column should not show: no data room for this entity type, a viewer
 * without `billing.manage` (the access read is refused to them), or no
 * current access. An Issue Report gets the column too: the buyer's row reads
 * Locked and everyone else's "Not transferable" (FR-138).
 *
 * @param entityId - the startup entity
 * @param enabled - false for an entity type with no data room, or a viewer without billing.manage
 */
export function useDataRoomSeatColumn(
  entityId: string,
  enabled: boolean,
): ((member: TeamMember) => ReactNode) | undefined {
  const access = useDataRoomAccess(entityId, enabled);
  const current = access.data?.current;
  if (!enabled || !current) return undefined;
  return function renderDataRoomSeat(member: TeamMember) {
    return <DataRoomSeatCell entityId={entityId} member={member} access={current} />;
  };
}
